import { IConfiguration, IConfig } from '@microsoft/applicationinsights-web';
import { InjectionToken, ValueProvider } from '@angular/core';

export interface AppInsightsConfig extends IConfiguration, IConfig { };

/** PROVIDE a string value with ApplicationInsights key or an exception will be thrown when module is loaded. */
export const AI_CONFIG = new InjectionToken<AppInsightsConfig>('AI_CONFIG');

/** Creates ValueProvider for an Ai configuration */
export function provideAiConfig(config: AppInsightsConfig): ValueProvider {
  return {
    provide: AI_CONFIG,
    useValue: config
  }
}
